export default __webpack_public_path__ + "static/media/arrow_right.fd67d355.svg";